document.addEventListener("turbo:load", function() {
  const SuccessOverlay = $("#js-toggle-success-overlay");
  const DeniedOverlay = $("#js-toggle-denied-overlay");

  if (SuccessOverlay.length > 0) {
    SuccessOverlay.on("click", function () {
      $("#js-temporary-user-overlay").hide();
      $("#js-cv-parser-overlay-success").addClass("active");
      
      // Scroll to overlay if needed
      $('html, body').animate({
        scrollTop: $("#js-cv-parser-overlay-success").offset().top - 100
      }, 500);
    });
  }

  if (DeniedOverlay.length > 0) {
    DeniedOverlay.on("click", function () {
      $("#js-temporary-user-overlay").hide();
      $("#js-cv-parser-overlay-denied").addClass("active");
      
      // Scroll to overlay
      $('html, body').animate({
        scrollTop: $("#js-cv-parser-overlay-denied").offset().top - 100
      }, 500);
    });
  }
  
  // Close overlay when delete form is submitted
  const DeleteFormDenied = $("#js-cv-parser-delete-form");
  const DeleteFormSuccess = $("#js-cv-parser-delete-form-success");
  
  if (DeleteFormDenied.length > 0) {
    DeleteFormDenied.on("submit", function () {
      $("#js-cv-parser-overlay-denied").removeClass("active").hide();
    });
  }
  
  if (DeleteFormSuccess.length > 0) {
    DeleteFormSuccess.on("submit", function () {
      $("#js-cv-parser-overlay-success").removeClass("active").hide();
    });
  }
});
